package kz.dentalcrm.app.data.network.response_model.diagnosis

import kotlinx.serialization.Serializable

@Serializable
data class DiagnosisResponse(
    val `data`: List<Diagnosis>? = null,
    val links: Links? = null,
    val meta: Meta? = null
)